<!-- 增改模块 -->
<template>
  <div>
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑模块' : '新增模块'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form
          ref="refForm"
          :column="formColumn"
          :data.sync="selfData"
          :rules="rules"
          @submit="popupConfirm"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    index: {
      type: [Number, String],
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      formColumn: [
        {
          type: 'text',
          field: 'name',
          title: '模块名称',
          width: '100%',
          required: true
        }
      ],
      rules: {
        name: [{ required: true, message: '请输入模块名称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initSelfData()
  },
  methods: {
    // 初始化数据
    initSelfData() {
      let result = {}
      if (this.index === '') {
        result = {
          name: '',
          list: []
        }
      } else {
        result = this.$util.deepCopy(this.list[this.index])
      }
      this.selfData = result
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          // 校验名称不能重复
          let list = this.$util.deepCopy(this.list)
          if (this.index !== '') {
            let result = this.list.filter((item, index) => {
              return index !== this.index
            })
            list = this.$util.deepCopy(result)
          }
          let isPass = list.every((item) => {
            return item.name !== this.selfData.name
          })
          if (!isPass) {
            this.$message.error('模块名称不能重复')
            return
          }

          this.$emit('success', this.selfData)
          this.popupCancel()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
